export const ExamineStatus = Object.freeze({
  /**
   * 已同意
   */
  normal: 'normal',
  /**
   * 已拒绝
   */
  success: 'success',
  /**
   * 已拒绝
   */
  refuse: 'refuse',

  options() {
    return [
      {
        label: '待审核',
        value: this.normal,
        type: 'primary'
      },
      {
        label: '已同意',
        value: this.success,
        type: 'success'
      },
      {
        label: '已拒绝',
        value: this.refuse,
        type: 'danger'
      }
    ]
  },
  filter(value) {
    return this.options().find(item => item.value === value) || {}
  }
})
